import styled from "styled-components"
import theme from "../../../theme"

const MainStyled = styled.main`
  background: ${theme.bgMain || "#fff"};
  /* color: #000; */
`

export default MainStyled
